import axios from "axios";
//import VueCookies from 'vue-cookies'
import permissions from '../classes/permissions';
import store from '../store';
import router from '../router';

export default {
    state: {

        loggedIn: null,
        token: "",
        permissions: {},
        shipmentTypes: [],
        username: "",
        role: "",
        organisation: {},
        language: "de",
        expired: false,
        menu: [],
        menuItems: [],
        allowEPL: false,
        allowStats: false,
        allowUpload: false,
        currentBuildHash: null,           // Hash der aktuell geladenen App
        isUpdateAvailable: false,         // Flag für die Benachrichtigung

    },
    getters: {
        userLoggedIn: state => {
            return state.loggedIn;
        },
        getToken: state => {
            return state.token;
        },
        getLoggedInUsername: state => {
            return state.username;
        },
        getUserLanguage: state => {
            return state.language;
        },
        getUserOrganisation: state => {
            return state.organisation;
        },
        getPermissions: state => {
            return state.permissions;
        },
        userExpired: state => {
            return state.expired;
        },
        getMenuItems: state => {
            return state.menuItems;
        },
        getCurrentBuildHash: state => {
            return state.currentBuildHash;
        },
         getIsUpdateAvailable: state => {
            return state.isUpdateAvailable;
        }

    },


    mutations: {


        setLoginState(state, payload) {
            state.loggedIn = payload;
        },
        setShipmentTypes(state, payload) {
            state.shipmentTypes = payload;
        },
        setExpired(state, payload) {
            state.expired = payload;
        },
        setUsername(state, payload) {
            state.username = payload;
        },
        setLanguage(state, payload) {
            state.language = payload;
        },
        setPermissions(state, payload) {
            state.permissions = payload;
        },
        setMenu(state, payload) {
            state.menu = payload;
        },
        setMenuItems(state, payload) {
            state.menuItems = payload;
        },
        setUser(state, payload) {
            console.log("setUserPayload", payload);
            state.loggedIn = payload.loggedIn;
            state.username = payload.username;
            state.language = payload.language;
            state.expired = payload.expired;
            state.allowStats = payload.allowStats;
            state.role = payload.role;
            state.allowEPL = payload.allowEPL;
            state.allowUpload = payload.allowUpload;
            state.organisation = payload.organisation;
            state.token = payload.token;
        },
        resetUser(state) {
            console.log("reset user!!!!!!!!!");
            state.loggedIn = false;
            state.username = "";
            state.language = "de";
            state.expired = false;
            state.allowEPL = false;
            state.allowUpload = false;
            state.allowStats = false;
            state.token = "";
            state.role = "";
            state.organisation = {};
            state.permissions = new permissions();
            let tmpMenu = structuredClone($menuItems);
            state.menuItems = tmpMenu;
            state.shipmentTypes = [];

        },
        setCurrentBuildHash(state, hash) {
            state.currentBuildHash = hash;
        },
        setIsUpdateAvailable(state, value) {
            state.isUpdateAvailable = value;
        }
    },
    actions: {

        /**
         * Logs the user in, then loads shipment types and language data.
         */

        login: ({ commit, dispatch }, payload) => {

            let params = payload;
            console.log("login (store)", params.uname, params.pw);
            if (params.uname.length > 0 && params.pw.length > 0) {
                return new Promise((resolve, reject) => {
                    axios({
                        method: 'post', url: process.env.VUE_APP_BACKEND_LOGON, data: payload, params: { format: "J", load: 1 }
                    })
                        .then(({ data, status }) => {
                            // handle success

                            if (status === 200 && data.status === true) {


                                let user = {};
                                user.loggedIn = true;
                                user.language = data.lang;
                                user.expired = data.expired;
                                user.username = params.uname;
                                user.allowEPL = data.allowEPL;
                                user.allowUpload = data.allowupload;
                                user.allowStats = data.allowstats;
                                user.role = data.btyp;
                                user.token = data.sesstoken;
                                user.organisation = data.orga;
                                console.log("setUser @ login", user.language);
                                commit('setUser', user);

                                //check if user.lang is same as getters.getLanguage if not load language
                                console.log("user.language", user.language);
                                console.log("store.state.lang.getLanguage", store.state.lang.getLanguage);
                                if (user.language !== store.state.lang.getLanguage) {
                                    dispatch('loadLanguage', { lang: user.language, save: false, reload: false });
                                }


                                Promise.all([

                                    dispatch('loadShipmentTypes')
                                ])
                                    .then(() => {
                                        // Both actions completed successfully
                                        resolve(true);
                                    }).catch(error => {
                                        // Handle errors if any of the actions fail
                                        reject(error);
                                    });
                            } else {
                                reject(data.msg);
                            }
                        })
                        .catch(function (error) {
                            // handle error

                            console.log(error);

                            reject(error);
                        })
                });
            }

        },
        /**
         * Logs the user out
         */
        logout: ({ commit }) => {
            console.log("logout from server");
            return new Promise((resolve, reject) => {
                axios({
                    method: 'get', url: process.env.VUE_APP_BACKEND_LOGOFF, params: { format: "J" }
                })
                    .then(({ data, status }) => {
                        // handle success

                        if (status === 200 && data.status <= 0) {
                            resolve(true);
                        }
                    })
                    .catch(function (error) {
                        // handle error


                        reject(error);

                    })
                    .finally(function () {
                        // always executed

                        console.log("loggedout from server now reset user in frontend");
                        commit('resetUser');



                    });
                //this.$cookies.remove("PHPSESSID");
            });
        },
        /**
         * Sends a password reset request to the server.
         */
        passwordReset: (params) => {
            axios({
                method: 'get', url: process.env.VUE_APP_BACKEND_PASSWORDRESET, params
            })
                .then(function (response) {
                    // handle success                
                    return response;

                })
                .catch(function (error) {
                    // handle error                   
                    console.log(error);
                    return false;

                })
                .finally(function () {
                    // always executed

                });
        },

        /**
         * Loads shipment types for the user from the server and stores them in store.
         */
        loadShipmentTypes: ({ commit }) => {
            return new Promise((resolve, reject) => {


                axios({
                    method: 'get',
                    url: process.env.VUE_APP_BACKEND_MENU,
                    params: { format: "J", getarten: 1 }
                })
                    .then(function (response) {
                        if (response.data) {

                            for (const shipmentType of response.data) {
                                for (const arten of shipmentType.arten) {
                                    arten.parentType = shipmentType.name;
                                }
                            }

                            commit('setShipmentTypes', response.data);
                            resolve(response.data); // Resolve with the data
                        }
                    })
                    .catch(function (error) {
                        console.error("Error loading ShipmentTypes", error);
                        reject(error); // Reject with the error
                    })
                    .finally(function () {

                    });
            });
        },


        /**
         * Loads the user's menu permissions and other permissions, and stores them in the Vuex store.
         */
        loadPermissions: ({ commit, state, getters }) => {


            console.log("loadPermissions");

            axios({
                method: 'get', url: process.env.VUE_APP_BACKEND_MENU, params: { format: "J" }
            })
                .then(function (response) {
                    // handle success




                    if (response.data.items) {
                        const items = response.data.items;

                        let tmpPerm = new permissions();
                        let tmpMenu = structuredClone($menuItems);

                        if (response.data.logged_on === true) {
                            tmpPerm.dashboard.viewPage = true;
                            tmpMenu.find(item => item.route === 'dashboard').active = true;
                        }


                        if (items[1]) {
                            tmpPerm.trackShipment.viewPage = true;
                            // find menu item by name trackShipment and set active to true
                            tmpMenu.find(item => item.route === 'track').active = true;


                            if (items[1].sub && items[1].sub[3]) {

                                tmpMenu.find(item => item.route === 'track').active = true;
                            }
                            if (items[1].sub && items[1].sub[11]) {
                                tmpPerm.damages.viewPage = true;
                                tmpPerm.damageReport.viewPage = true;
                                tmpPerm.damageReport.actions.create = false;
                                tmpMenu.find(item => item.route === 'damages').active = true;

                            }
                            if (items[1].sub && items[1].sub[5]) {
                                tmpPerm.returnableContainer.viewPage = true;
                                tmpMenu.find(item => item.route === 'returnableContainer').active = true;
                                tmpPerm.returnableContainer.tab3 = true;

                            }
                            if (items[1].sub && items[1].sub[6]) {
                                tmpPerm.returnableContainer.viewPage = true;
                                tmpMenu.find(item => item.route === 'returnableContainer').active = true;
                                tmpPerm.returnableContainer.tab4 = true;
                            }
                            if (items[1].sub && items[1].sub[16]) {
                                tmpPerm.returnableContainer.viewPage = true;
                                tmpMenu.find(item => item.route === 'returnableContainer').active = true;
                                tmpPerm.returnableContainer.tab2 = true;
                            }


                        }
                        if (items[2]) {


                            if (items[2].sub && items[2].sub[2]) {
                                tmpPerm.returnableContainer.viewPage = true;
                                tmpMenu.find(item => item.route === 'returnableContainer').active = true;
                                tmpPerm.returnableContainer.tab1 = true;
                            }



                        }
                        if (items[7]) {
                            tmpPerm.newShipment.viewPage = true;


                            tmpMenu.find(item => item.route === 'newShipment').active = true;
                            tmpMenu[2].active = true;
                            tmpMenu[1].active = true;
                            if (items[7].sub) {
                                if (items[7].sub[4]) {

                                    tmpPerm.newShipment.actions.CT.create = true;
                                    tmpPerm.newShipment.actions.CT.label = items[7].sub[4].text;
                                    tmpPerm.contacts.viewPage = true;
                                    tmpMenu.find(item => item.route === 'contacts').active = true;
                                }
                                if (items[7].sub[6]) {

                                    tmpPerm.damageReport.viewPage = true;
                                    tmpPerm.damageReport.actions.create = true;
                                    tmpMenu.find(item => item.route === 'damageReport').active = true;

                                }
                                if (items[7].sub[8]) {

                                    tmpPerm.loadingList.viewPage = true;                                    
                                    tmpMenu.find(item => item.route === 'loadingList').active = true;

                                }

                            }

                        }
                        if (items[13]) {
                            if (items[13].sub) {
                                if (items[13].sub[7]) {
                                    tmpPerm.ticket.viewPage = true;
                                    tmpMenu.find(item => item.route === 'ticket').active = true;

                                }
                                if (items[13].sub[3]) {
                                    tmpPerm.userProfile.actions.changePassword = true;
                                }
                                if (items[13].sub[4]) {
                                    tmpPerm.userProfile.actions.installPrinter = true;
                                }

                            }
                        }
                        commit('setPermissions', tmpPerm);
                        commit('setMenu', response.data.items);
                        commit('setMenuItems', tmpMenu);
                    }

                    /*   console.log("frontend.loggedIn", getters.userLoggedIn, "backend.logged_on", response.data.logged_on);
  
                      if (getters.userLoggedIn === true && response.data.logged_on === false) {
                        
                         console.log("i want to reset the user and kick you out");
                         commit('resetUser');                               
                         this.$router.push('/'); 
  
                     }if (getters.userLoggedIn === false && response.data.logged_on === true) {
                         console.log("i want to log you out on the server");
                 
                         console.log("user is logged out from backend also logged in from frontend");
                      
         
                     } */


                    return true

                })
                .catch((error) => {
                    // handle error
                    // console.error(error);
                    //this.$store.dispatch("showMessage",{type:"Error",text:error});            
                    //commit('setPermissions', new permissions());
                    //return false;
                })
                .finally(function () {
                    // always executed

                });
        },
        /**
         * Checks whether the user is still logged in on the server.  
         * Redirects to the homepage if the user was logged out.  
         * If there's a mismatch between frontend and backend login status, frontend data will be corrected.
         */
        async checkUser({ commit, dispatch, getters }) {

            axios({
                method: 'get',
                url: process.env.VUE_APP_BACKEND_LOGON,
                params: {
                    format: 'J'

                }
            })
                .then(function (response) {
                    // handle success
                    if(response.data){
                    console.log("check User");
                    const serverBuildHash = response.data.buildHash;

                    // Versions-Vergleich (Nur in Produktion, wenn wir den Client-Hash kennen) ---
                    if (process.env.NODE_ENV === 'production' && getters.getCurrentBuildHash) {

                        if (serverBuildHash && serverBuildHash !== getters.getCurrentBuildHash) {
                            // NEUE VERSION GEFUNDEN!
                            console.warn(`[VERSION] Update verfügbar! Aktuell: ${getters.getCurrentBuildHash}, Server: ${serverBuildHash}`);

                            // Setze das Flag, um das erzwungene Update-Modal anzuzeigen (Camel Case)
                            commit('setIsUpdateAvailable', true);

                            // Beenden, da der Benutzer zur Aktualisierung gezwungen werden soll.
                            return;
                        }
                    } else if (process.env.NODE_ENV !== 'production') {
                        // Hier wissen wir: Wir sind im DEV-Modus.
                        //commit('setIsUpdateAvailable', true);
                        const clientHash = getters.getCurrentBuildHash || 'FEHLT (App.vue Logik)';

                        console.groupCollapsed('[DEV-INFO] Versions-Check übersprungen');
                        console.log(`Modus: DEVELOPMENT`);
                        console.log(`Client Hash: ${clientHash}`);
                        console.log(`Server Hash (von API): ${serverBuildHash || 'FEHLT'}`);

                        // Simuliere den Update-Vergleich, falls Hashes vorhanden sind
                        if (clientHash !== 'DEV-HASH' && serverBuildHash && serverBuildHash !== clientHash) {
                            // Der Fall, dass Hashes vorhanden wären, aber wir ignorieren es im DEV-Modus
                            console.warn(`Simulierter Update-Status: UPDATE WÄRE IN PROD ERFORDERLICH!`);
                           //  commit('setIsUpdateAvailable', true);

                        } else if (serverBuildHash === clientHash) {
                            console.info(`Simulierter Update-Status: Hash ist aktuell.`);
                        }

                        console.groupEnd();
                    }

                    if (response.data.status === false) {
                        if (getters.userLoggedIn === true) {
                            commit('resetUser');
                            dispatch('loadPermissions');

                            if (router.currentRoute.path !== '/') {
                                router.push('/');
                            }
                        }

                    } else {

                        if (getters.userLoggedIn === false || getters.getLoggedInUsername !== response.data.uname) {
                            dispatch('loadShipmentTypes');
                            dispatch('loadPermissions');
                            dispatch('loadUserDetails');
                        }


                    }
                    }

                })
                .catch(function (error) {
                    // handle error
                    console.error(error);
                    //commit('resetUser');
                })
                .finally(function () {
                    // always executed
                });
        },
        /**
         * Loads user details from the server and stores it in the store.
         */
        loadUserDetails: ({ commit, dispatch, getters }) => {
            console.log("!loadUserDetails");
            axios({
                method: 'get',
                url: process.env.VUE_APP_BACKEND_LOGON,
                params: {
                    format: 'J',
                    load: 1
                }
            })
                .then(function (response) {
                    // handle success

                    if (response.data.status === true) {

                        let user = {};
                        user.loggedIn = response && response.data && response.data.status ? response.data.status : false;
                        user.language = response && response.data && response.data.lang ? response.data.lang : 'de';
                        user.expired = response && response.data && response.data.expired ? response.data.expired : false;
                        user.username = response && response.data && response.data.uname ? response.data.uname : '';
                        user.token = response && response.data && response.data.sesstoken ? response.data.sesstoken : '';
                        user.allowEPL = response && response.data && response.data.allowEPL ? response.data.allowEPL : false;
                        user.role = response && response.data && response.data.btyp ? response.data.btyp : false;
                        user.allowStats = response && response.data && response.data.allowstats ? response.data.allowstats : false;
                        user.allowUpload = response && response.data && response.data.allowupload ? response.data.allowupload : false;
                        user.organisation = response && response.data && response.data.orga ? response.data.orga : false;
                        commit('setUser', user);

                    } else {
                        commit('resetUser');
                    }

                })
                .catch(function (error) {
                    // handle error
                    console.error(error);
                    //commit('resetUser');
                })
                .finally(function () {
                    // always executed
                });
        },


    }
};
